import React, { useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Row, Col } from 'reactstrap';
import { ApplicationState } from "../store";
import { connect } from 'react-redux';
import * as AuthorizationStore from '../store/Authorization';
import { bindActionCreators } from "redux";
import GenericDropdownAsync from "../components/controls/GenericDropdownAsync";
import ImpactPartnerService from "../services/ImpactPartnerService";
import { ImpactPartner } from "../models/ImpactPartner";

const AzureADAuthenticate = (props: {
    authorization: AuthorizationStore.IState;
    authorizationActions: typeof AuthorizationStore.actionCreators;
    rootCtrlProps?: React.HTMLAttributes<HTMLElement>;
}) => {

    const [selectedPartner, setPartner] = useState<ImpactPartner>();

    const getAzureAuth = () => {
        props.authorizationActions.getAzureAuthCode(selectedPartner);
    }

    useEffect(() => {
        async function logout() {
            await props.authorizationActions.getAzureConfigurations();
            await props.authorizationActions.logout();
        }
        logout();
    }, []);

    return (
        <div className="p-3 container">
            <Row>
                <Col md={4} className="offset-md-4 pr-md-0">
                    <Form>
                        <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                            <Label className="mr-sm-2">Impact Partner</Label>
                            <GenericDropdownAsync
                                loadDataSource={() => ImpactPartnerService.loginList()}
                                getId={x => x.Id}
                                renderItem={x => x.Name}
                                renderSelectedItem={x => x ? x.Name : ''}
                                selectedValue={selectedPartner ? selectedPartner.Id : undefined}
                                onSelectedItemChanged={x => setPartner(x)}
                            />
                        </FormGroup>
                        <div className="d-flex align-items-center justify-content-center">
                            <Button color="primary" className="rounded-0 px-5 text-uppercase mt-2"
                                disabled={selectedPartner === undefined}
                                onClick={() => getAzureAuth()}>Login</Button>
                        </div>
                    </Form>
                </Col>
            </Row>
        </div>
    );
};

export default connect((state: ApplicationState) => ({
    authorization: state.authorization
}), // Selects which state properties are merged into the component's props
    (dispatch, getState) => ({
        authorizationActions: bindActionCreators(AuthorizationStore.actionCreators, dispatch)
    })
)(AzureADAuthenticate);